import React, { useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import { useAuth } from "hooks/Auth";
import LoaderShell from "components/LoaderShell";

export default function IndexScreen(props) {
    const auth = useAuth();
    const history = useHistory();
    const authRef = useRef();

    useEffect(() => {
        if (!authRef.current) {
            authRef.current = true;
            auth.verifyAuth().then((didAuthenticate) => {
                history.push("/app/dashboard");
            });
        }
        // eslint-disable-next-line
    }, [auth, authRef]);

    return <LoaderShell />;
}
